import { useRef } from "react";
import { Camera, X } from "lucide-react";

/**
 * Photo upload control. Stores as base64 data URL via FileReader.
 * onChange(dataUrl | null)
 */
export default function PhotoUpload({ value, onChange, label = "Subir foto", testId = "photo-upload" }) {
    const inputRef = useRef(null);

    const handleFile = (file) => {
        if (!file) return;
        const reader = new FileReader();
        reader.onload = () => onChange(reader.result);
        reader.readAsDataURL(file);
    };

    if (value) {
        return (
            <div className="relative inline-block" data-testid={testId}>
                <img src={value} alt="evidencia" className="zentra-photo-thumb w-40" />
                <button
                    type="button"
                    onClick={() => onChange(null)}
                    className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-red-600 text-white flex items-center justify-center shadow-md hover:bg-red-700"
                    data-testid={`${testId}-remove`}
                    aria-label="Eliminar foto"
                >
                    <X size={14} />
                </button>
            </div>
        );
    }

    return (
        <button
            type="button"
            className="border-2 border-dashed border-zentra-border rounded-lg p-5 flex flex-col items-center justify-center gap-2 bg-white hover:bg-zentra-bg transition-colors w-40 aspect-[4/3] text-zentra-muted hover:text-zentra-primary hover:border-zentra-olive"
            onClick={() => inputRef.current?.click()}
            data-testid={`${testId}-button`}
        >
            <Camera size={22} strokeWidth={1.6} />
            <span className="text-xs font-medium">{label}</span>
            <input
                ref={inputRef}
                type="file"
                accept="image/*"
                className="hidden"
                onChange={(e) => handleFile(e.target.files?.[0])}
                data-testid={`${testId}-input`}
            />
        </button>
    );
}
